var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00038 10.5H5.00038M9.00038 4C9.00038 3.20435 8.68431 2.44129 8.1217 1.87868C7.55909 1.31607 6.79603 1 6.00038 1C5.20473 1 4.44166 1.31607 3.87906 1.87868C3.31645 2.44129 3.00038 3.20435 3.00038 4C3.00038 5.54509 2.61061 6.60298 2.17521 7.30271C1.80794 7.89294 1.6243 8.18805 1.63104 8.27038C1.63849 8.36154 1.65781 8.3963 1.73126 8.45079C1.79761 8.5 2.09667 8.5 2.6948 8.5H9.30595C9.90408 8.5 10.2031 8.5 10.2695 8.45079C10.3429 8.3963 10.3623 8.36154 10.3697 8.27038C10.3764 8.18805 10.1928 7.89294 9.82554 7.30271C9.39014 6.60298 9.00038 5.54509 9.00038 4Z",
    stroke: "#414651",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell02);
export default __webpack_public_path__ + "static/media/bell-02.8f976b71296aa5f2fbfdb0b86b986912.svg";
export { ForwardRef as ReactComponent };